import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

// 本地持久化
const getDefault = function (name, defaultValue) {
  let result = defaultValue;
  try {
    if (localStorage.getItem(name)) {
      result = JSON.parse(localStorage.getItem(name));
    }
    return result;
  } catch (e) {
    return result;
  }
};

const state = {
  userInfo: getDefault('userInfo', {}), // 用户信息
  timeZone: localStorage.getItem('timeZone') || '+08:00', // 地区时差
  timeZoneId: localStorage.getItem('timeZoneId') || 'Asia/Beijing', // 地区编码
  dateFormat: localStorage.getItem('dateFormat') || 'YYYY-MM-DD', // 日期转换
  isTime24h: localStorage.getItem('isTime24h') || '1', // 是否24h
  pswdLoginChange: localStorage.getItem('pswdLoginChange') || '0', // 首次登录
  menuObj: {}, // 菜单Map对象
  funcView: {}, // 功能Map对象
  messageNum: null, // 消息数量
};

const getters = {
  isAdmin: states => states.userInfo.bizType === 'PF'
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
});
